import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  Typography,
  CircularProgress,
  Stack,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { InputField } from "../../../components/ui/Inputs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SelectOptions from "../../../components/ui/SelectOptions";
import { PrimaryButton, SecondaryButton ,SecondaryButtonText} from "../../../components/ui/Button";
import { useForm, Controller } from "react-hook-form";
import filterIcon from "./../../../assets/images/icons/filter.png";
import Tables from "../../../components/ui/Tables";
import ModalPopup from "../../../components/ui/ModalPopup";
import BasicDatePicker from "../../../components/ui/BasicDatePicker";
import { formatIndianRupees } from "../../../utils/formatting";
import { RootState } from "../../../services/redux/store";
import { useDispatch, useSelector } from "react-redux";
import service from "../../../services/api/service";
import {
  authSelector,
  userPermissionSelector,
  userLoanCatSelector,
} from "../../../services/redux/slices/authSlice";
import postsServices from "../../../services/api/service/postsService";
import Toast from "../../../components/ui/Toast";
import PaperCard from "../../../components/ui/PaperCard";
import InfoIcon from "./../../../assets/images/icons/info.png";
import { messages, filterOptionsPartPay } from "../../../data/constant";
import dayjs from "dayjs";
import { formatDate, formatNormalDate } from "../../../utils/dateFormatUtils";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { encrypt } from "../../../utils/crypto";
import { PaymentTermLoanContext } from "../../../hooks/context";
import PaymentRequestTermLoan from "./paymentTerm/PaymentRequestTermLoan";
import PartPaymentTermLoan from "./paymentTerm/PartPaymentTermLoan";
import AdditionalDetailsLoan from "./paymentTerm/AdditionalDetailsLoan";
import ProceedToPayLoan from "./paymentTerm/ProceedToPayLoan";
import PaymentDetailPage from "./paymentTerm/PaymentDetailPage";
import OverdueLoanRequest from "./paymentTerm/OverdueLoanRequest";
import Card from "../../../components/ui/Card";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  clearPartPaymentType,
  setPartPaymentType,
} from "../../../services/redux/slices/documentFormSlice";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import CardItemTermPayment from "../../../components/ui/mobile/CardItemTermPayment";
import { decrypt } from "../../../utils/crypto";
import ReactGA from "react-ga4";
import { paymentLimit } from "../../../data/constant";
import { trackEvent } from "../../../utils/ga";

interface Column {
  id: string;
  label: string;
  align?: "right";
  format?: (value: number) => string;
}
interface DashboardItemType {
  loanType: any;
  totalLimit: any;
  availableLimit: any;
  outstanding: any;
  overdueAmount: any;
  overdueBreakup: any;
  overdueTotal: any;
  overDueCharges: any;
  fees: any;
  dashboardData: any;
  totalPrincipalOutstanding: any;
  statusOfLoan: any;
  lanNumber: any;
  paymentOutstandingPrincipal: any;
  repayAmount: any;
  outstandingPrincipal: any;
}
export interface RowData {
  [key: string]: string | number | null;
}

const PaymentTermLoan = () => {
  const { setValue } = useForm();
  const theme = useTheme();
  const initialFetchPyment = useRef(true);
  const initialFetch = useRef(true);

  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const userLoanCategory = useSelector(userLoanCatSelector);
  const { userProfile } = useSelector(authSelector);
  const [amountValue, setAmountValue] = useState<number | null>(null);
  const [formStep, setFormStep] = useState<any>(-1);
  const [partPaymentData, setPartPaymentData] = useState<any>([]);
  const [formValue, setFormValue] = useState<any>({
    cif: "",
    cifEntity: "",
    lan: "",
    amount: "",
    paymentType: "PartPayment",
    initiatedBy: "",
    sourceFundsUuid: "",
    desiredImpactUuid: "",
    netPrincipalAdjustment: "",
    reasonForPartPayment: "",
    payTowardsOverdue: 0,
  });

  const [termLoanRequestId, setTermLoanRequestId] = useState<any>("");
  const [applicableCharges, setApplicableCharges] = useState<number>(0);
  // State hooks
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [overdueAmount, setOverdueAmount] = useState(0);
  const [selectedOptionValue, setSelectedOptionValue] = useState<
    string | number
  >("");
  const { rolePermissions } = useSelector(userPermissionSelector);
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [dashboardData, setDashboardData] = useState<DashboardItemType>();
  const [selectedOptionFilterValue, setSelectedOptionFilterValue] = useState<
    string | number
  >("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");
  const [inputValue, setInputValue] = useState("");
  const [nagitiveValueCheck, setNagitiveValueCheck] = useState("");
  const [disabledButton, setdisabledButton] = useState(false);
  const [lanNumber, setLanNumber] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [paymentTypeValue, setPaymentTypeValue] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingTableCard, setIsLoadingTableCard] = useState(true);

  const [pending, setPending] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rows, setRows] = useState<RowData[]>([]);
  const [page, setPage] = useState(0);
  const [overDueValues, setOverDueValues] = useState<any>(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [statusUpdate, setstatusUpdate] = useState("");
  const [paymentType, setpaymentType] = useState("");
  const dispatch = useDispatch();

  const [isOverDuePending, setIsOverDuePending] = useState(true);

  const formTypeValue = useSelector(
    (state: RootState) => state.documentFormSlice.partPaymentType
  );

  const handleSelectPaymentType = (value: string) => {
    setpaymentType(value);
  };

  const handleEmptyFormValue = () => {
    setFormValue({
      cif: "",
      cifEntity: "",
      lan: "",
      amount: "",
      paymentType: "PartPayment",
      initiatedBy: "",
      sourceFundsUuid: "",
      desiredImpactUuid: "",
      netPrincipalAdjustment: "",
      reasonForPartPayment: "",
      payTowardsOverdue: 0,
    });
  };

  // --------------------------------------------------code for URL Data----------------------------------------
  const parseCustomQueryString = (queryString: any) => {
    const cleanedQueryString = queryString.startsWith("?")
      ? queryString.substring(1)
      : queryString;

    const correctedQueryString = cleanedQueryString.replace(/\?/g, "&");
    const paramPairs = correctedQueryString.split("&");
    const params: any = {};

    paramPairs.forEach((pair: any) => {
      const [key, value] = pair.split("=");

      if (key && value) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    });

    return params;
  };
  const parsedParams = parseCustomQueryString(window.location.search);
  let cif: any;
  let LoanNo: any;

  if ("error" in parsedParams) {
    cif = parsedParams.cif;
  } else {
    cif = parsedParams.cif;
  }
  if ("error" in parsedParams) {
    LoanNo = parsedParams["loanNo"];
  } else {
    LoanNo = parsedParams["LoanNo"];
  }
  const paymentRequestId = parsedParams["paymentRequestId"];

  const selectedLoanNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );
  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  const dashboardDataSetTest = useSelector(
    (state: RootState) => state.dashboardData
  );

  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );
  // ==================================================================================================================================

  /**
   * Fetches finance data from the specified API endpoint.
   *
   * This function makes an HTTP GET request to the finance API to retrieve finance data
   * for a specific entity. The request includes necessary headers such as authorization,
   * language, entity ID, service name, service version, message ID, and request time.
   *
   * @async
   * @function fetchGetFinanceRestData
   *
   * @returns {Promise<void>} A promise that resolves when the data is successfully fetched
   * and logged to the console, or rejects with an error if the request fails.
   */
  const fetchGetFinanceRestData = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const payload: any = {
        lan: encrypt(selectedLoanNumber.toString()),
        business: encrypt(businessTypeId),
        loanCategory: encrypt(loanCategoryData?.TermLoan[0]?.loanCategoryId),
      };
      postsServices
        .addPost("/api/v1/dashboard/term-loan-view", payload)
        .then((response) => {
          setPartPaymentData(response?.data?.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          // const errorMessage =
          //   error.response?.data?.message ||
          //   messages.withdrErrorMessages.commonError;
          // dispatch(setStatusPopup({ status: "error", message: errorMessage }));
        });
    } catch (error: any) {
      setIsLoading(false);
      if (error?.response?.status === 408) {
        const errorMessage = error?.response?.data?.details?.error;
        dispatch(
          setStatusPopup({
            status: "error",
            message: errorMessage,
            buttonStatus: true,
          })
        );
      } else if (error?.response?.data) {
        const errorMessage = error?.response?.data?.message;
        dispatch(
          setStatusPopup({
            status: "error",
            message: errorMessage,
          })
        );
      }
    }
  };

  /**
   * Fetches additional charges data from the server.
   *
   * This function makes an asynchronous call to the endpoint `/api/v1/payment/get-desired-impacts`
   * to retrieve additional charges data. The response data is logged to the console.
   * If an error occurs during the request, it is caught and logged to the console.
   *
   * @async
   * @function getAdditionalChargesData
   * @returns {Promise<void>} A promise that resolves when the data has been fetched and logged.
   */
  const getAdditionalChargesData = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const payload = {
        type: encrypt("PartPayment"),
        lan: encrypt(selectedLoanNumber),
        cif: userProfile?.cifNumber,
      };

      await postsServices
        .addPost("/api/v1/payment/get-additional-charges", payload)
        .then((response: any) => {
          setApplicableCharges(response?.data?.data);
          setpaymentType("");
          setIsLoading(false);
        })
        .catch((error: any) => {
          console.log(error);
          setIsLoading(false);
        });
    } catch (error: any) {
      console.log(error);
    }
  };

  // ==================================================================================================================================

  // --------------------------------------------------code for URL Data----------------------------------------
  const handleToastClose = () => {
    setToastOpen(false);
  };
const clearData = () => {
    setIsModalOpen(false);
    setSelectedOptionFilterValue("");
    setFromDate(null);
    setToDate(null);
    fetchData(null,null,"");
  };
  const handleFilterButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // setSelectedOptionFilterValue("");
    // setFromDate(null);
    // setToDate(null);
  };

  const handleListItemClick = (option: any) => {
    setValue("amount", "");
    setErrorMessage("");
    handleSelectPaymentType(option);
    if (option === "1") {
      setPaymentTypeValue("overdue");
    } else {
      setPaymentTypeValue("PartPayment");
    }
  };
  // Redux selectors
  // -------------------------------------New Code---------------------------------------

  useEffect(() => {
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.lanNumber === selectedLoanNumber
    );

    setDashboardData(matchedObject);
    setErrorMessage("");
    setValue("amount", "");
  }, [selectedLoanNumber, dashboardDataSet]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setdisabledButton(false);
    let value = e.target.value.replace(/\D/, "");
    const numericValue = parseInt(value, 10);
    const outstandingValue = dashboardData?.totalPrincipalOutstanding / 100 - 2;
    const outstandingValueBefourMin =
      dashboardData?.totalPrincipalOutstanding / 100;
    const overDueValue = dashboardData?.overdueAmount / 100;

    const inputValue: any = e.target.value;

    if (inputValue > paymentLimit) {
      setErrorMessage(
        "Per transaction limit for Part Payment and Overdue Payment is 9 Lakhs"
      );
      return;
    }

    if (inputValue < 0) {
      e.target.value = "0";
    }
    if (formTypeValue === "2") {
      if (numericValue > outstandingValue) {
        value = outstandingValue.toString();
        if (outstandingValueBefourMin <= 2 && outstandingValueBefourMin > 0) {
          setErrorMessage(messages.paymentErrorMessages.partPayment);
        } else {
          setErrorMessage(
            `${messages.paymentErrorMessages.partPayment2} ${outstandingValue}`
          );
        }
      } else {
        setErrorMessage("");
      }
      setInputValue(value);
      setNagitiveValueCheck(e.target.value);
    } else if (formTypeValue === "1") {
      if (numericValue > overDueValue) {
        value = overDueValue.toString();
        setErrorMessage(messages.paymentErrorMessages.overdue);
      } else {
        setErrorMessage("");
      }
      setInputValue(value);
      setNagitiveValueCheck(inputValue);
    }
  };
  // -------------------------------------New Code---------------------------------------
  const selectedOption = useSelector(
    (state: RootState) => state.option.selectedOption
  );
  const loanAccountNumberOptions = useSelector(
    (state: RootState) => state.option.loanAccountNumberOptions
  );

  useEffect(() => {
    if (loanAccountNumberOptions && loanAccountNumberOptions.length > 0) {
      setLanNumber(loanAccountNumberOptions[0]);
    }
  }, [loanAccountNumberOptions]);

  useEffect(() => {
    if (
      selectedOption &&
      loanAccountNumberOptions &&
      loanAccountNumberOptions.length > 0
    ) {
      const selectedLAN = loanAccountNumberOptions.find(
        (option: any) => option === selectedOption
      );
      if (selectedLAN) {
        setLanNumber(selectedLAN);
      }
    }
  }, [selectedOption, loanAccountNumberOptions]);
  const sanctionedDisbursedData = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  // Fetch and filter dashboard data based on selectedOption
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedOption;
      }
    );
    // setDashboardData(filteredDashboardData);
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );
  }, [sanctionedDisbursedData, selectedOption]);

  // Effect to update dashboard data and overdue amount based on selectedloanAccountNumber
  const selectedloanAccountNumber = useSelector(
    (state: RootState) => state.option.selectedloanAccountNumber
  );
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedloanAccountNumber;
      }
    );
    //setDashboardData(filteredDashboardData[0]);
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );
  }, [selectedloanAccountNumber]);

  useEffect(() => {
    const value: string = localStorage.getItem("termLoanRequestId") || "";
    if (value) {
      setTermLoanRequestId(value);
      setFormStep(3);
      dispatch(setPartPaymentType(formValue?.paymentType === "PartPayment" ? "1" : "2"))
    }
  }, [paymentRequestId, cif, LoanNo]);

  /**
   * Handles the action click event for a row in the term loan table.
   * Sets the term loan request ID based on the selected row.
   *
   * @param {any} row - The selected row data from the term loan table.
   */
  const handleActionClick = (row: any) => {
    trackEvent("Dash_Pay_View", decrypt(userProfile?.id), {
      label: "Dash_Pay_View",
      category: "Dash_Pay_View",
      action: "Dash_Pay_View",
    });

    const rowFilter: any = rows.find((item) => item.requestId === row);
    dispatch(
      setPartPaymentType(rowFilter?.purpose == "PartPayment" ? "1" : "2")
    );
    setTermLoanRequestId(rowFilter?.requestId);
    localStorage.setItem("payType", rowFilter?.purpose == "PartPayment" ? "PartPayment" : "OverDue");
    localStorage.setItem("termLoanRequestId", rowFilter?.requestId);
    setFormStep(3);
  };

  const columns: Column[] = [
    {
      id: "requestAt",
      label: "Date",
      format: (rowData: any) => rowData.requestAt,
    },

    {
      id: "requestId",
      label: "Request ID",
      format: (rowData: any) => rowData.requestId || "-",
    },
    {
      id: "trackingId",
      label: "Tracking ID",
      //format: (rowData: any) => rowData.trackingId || "-",
    },
    {
      id: "purpose",
      label: "Purpose",
      format: (rowData: any) => rowData.purpose || "-",
    },
    {
      id: "totalAmount",
      label: "Total Amount",
    },
    {
      id: "amountPaid",
      label: "Amount Paid",
    },
    {
      id: "initiatedBy",
      label: "Initiated By",
    },
    {
      id: "view_status",
      label: "Status",
      format: (rowData: any) => (
        <span
          className="click-to-pay"
          onClick={() => handleActionClick(rowData)}
        >
          View Status
        </span>
      ),
    },
  ];

  // Update selected state based on overdueAmount
  const handleFromDateChange = (date: Date | null) => {
    if (date) {
      const fromDateDayjs = dayjs(date);
      setFromDate(fromDateDayjs.toDate());
    } else {
      setFromDate(null);
    }
  };
  const handleToDateChange = (date: Date | null) => {
    if (date) {
      const toDateDayjs = dayjs(date);
      setToDate(toDateDayjs.toDate());
    } else {
      setToDate(null);
    }
  };

  const fetchData = async (fromDate: Date | null,
    toDate: Date | null,
    selectedOptionFilterValue: string | number) => {
    setIsLoadingTableCard(true);
    const formattedFromDate = fromDate
      ? dayjs(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? dayjs(toDate).format("YYYY-MM-DD") : "";
    const statusQuery =
      selectedOptionFilterValue === "all" ? "" : selectedOptionFilterValue;
    const payload: any = {
      lan: String(encrypt(selectedLoanNumber)),
      cif: String(userProfile?.cifNumber),
      status: statusQuery,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
    };
    const pageSkip = page + 1; // API might be 1-based indexing
    const pageSize = rowsPerPage;
    try {
      const response = await service.posts.addPost(
        `api/v1/payment/term-payment-dashboard-listing?page=${pageSkip}&pageSize=${pageSize}`,
        payload
      );
      setRows(response.data.data);
      setTotalRecords(response?.data?.totalCount);
    } catch (error) {
    } finally {
      setIsLoadingTableCard(false);
    }
  };

  useEffect(() => {
    setIsOverDuePending(true);
  }, [selectedLoanNumber]);

  /**
   * Fetches overdue data for the selected loan number.
   *
   * This function sets the loading state to true, constructs a payload with the encrypted
   * loan number, and makes a POST request to the `api/v1/payment/overdue-details` endpoint.
   * If the request is successful, it updates the overdue values state with the response data.
   * Regardless of the outcome, it sets the loading state to false once the request is complete.
   *
   * @async
   * @function fetchOverDueData
   * @returns {Promise<void>} A promise that resolves when the data fetching is complete.
   */
  const fetchOverDueData = async (): Promise<void> => {
    const payload: any = {
      lan: String(encrypt(selectedLoanNumber)),
      cif: userProfile?.cifNumber,
    };
    try {
      const response: any = await service.posts.addPost(
        `api/v1/payment/overdue-details`,
        payload
      );

      const keyValues = Object.keys(response?.data?.data);
      if (keyValues.length > 0) {
        // response.data.data.totalAmount = 11;
        setOverDueValues(response.data.data);
      } else {
        setOverDueValues({
          bounceCharge: 0,
          penalCharge: 0,
          emiWithoutCharge: 0,
          totalAmount: 0,
        });
      }
      setIsOverDuePending(false);
    } catch (error: any) {
      setIsOverDuePending(false);
      setOverDueValues(null);
    }
  };

  useEffect(() => {
    if (selectedLoanNumber && formStep == -1) {
      // if (initialFetch.current) {
      //   initialFetch.current = false;
      // } else {
      getAdditionalChargesData();
      fetchOverDueData();
      // }
    }
  }, [selectedLoanNumber, userProfile, formStep]);
  useEffect(() => {
    fetchData(null,null,"");
  }, [selectedLoanNumber]);
  useEffect(() => {
    // if (initialFetchPyment.current) {
    //   initialFetchPyment.current = false;
    // } else {
    fetchData(fromDate,toDate,selectedOptionFilterValue);
    //}
  }, [page, rowsPerPage, statusUpdate, formStep]);

  useEffect(() => {
    // if (initialFetch.current) {
    //   initialFetch.current = false;
    // } else {
    fetchGetFinanceRestData();
    // }
  }, [selectedLoanNumber]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    fetchData(fromDate,toDate,selectedOptionFilterValue);
  };
  const filterData = () => {
    setPage(0);
    setRowsPerPage(5);
    fetchData(fromDate,toDate,selectedOptionFilterValue);
    setIsModalOpen(false);
    // setSelectedOptionFilterValue("");
    // setFromDate(null);
    // setToDate(null);
  };

  const steps: any = [
    "Part Payment Amount",
    "Additional details",
    "Proceed to pay",
  ];

  const mobileSteps: any = [
    "Request Form",
    "Additional details",
    "Proceed to pay",
  ];

  const handleShowFormSection = useMemo(() => {
    switch (formStep) {
      case 0:
        return <PartPaymentTermLoan />;
      case 1:
        return <AdditionalDetailsLoan />;
      case 2:
        return <ProceedToPayLoan />;
      default:
        return <PaymentDetailPage />;
    }
  }, [formStep, formTypeValue]);

  const handleShowOverdueForm = useMemo(() => {
    switch (formStep) {
      case 0:
        return <OverdueLoanRequest />;
      default:
        return <PaymentDetailPage />;
    }
  }, [formStep, formTypeValue]);

  /**
   * Calculates the number of filled fields in a given form value object.
   *
   * @param formValue - An object representing the form values, where keys are field names and values are field values.
   * @returns The count of fields that have non-empty, non-null, and non-undefined values.
   */
  const calculateFilledFieldsCount = (
    formValue: Record<string, any>
  ): number => {
    // Count keys that have non-empty or non-null values
    return Object.values(formValue).filter(
      (value) => value !== null && value !== undefined && value !== ""
    ).length;
  };

  /**
   * Calculates the completion percentage value based on the number of filled fields and the current form step.
   *
   * The completion percentage is calculated by dividing the number of filled fields by the total number of fields
   * and then multiplying by 100. The result is rounded to the nearest integer.
   *
   * Depending on the current form step, the function ensures a minimum completion percentage:
   * - Step 0: Minimum 33%
   * - Step 1: Minimum 66%
   * - Step 2: Minimum 100%
   *
   * @param {Object} formValue - The current form values.
   * @param {number} formStep - The current step of the form.
   * @returns {number} - The calculated completion percentage.
   */
  const handleCompletionPercValue = useMemo(() => {
    const totalFields = 11;
    const filledFieldsCount = calculateFilledFieldsCount(formValue);
    const progress = Math.round(
      ((filledFieldsCount * 1.84) / totalFields) * 100
    );

    // Return progress or default to step-based completion if needed
    if (formStep === 0) {
      return Math.max(0); // Ensure minimum 33% for step 0
    } else if (formStep === 1) {
      return Math.max(50); // Ensure minimum 66% for step 1
    } else if (formStep === 2) {
      return Math.max(100); // Ensure 100% for step 2
    } else {
      return progress; // Default to calculated progress
    }
  }, [formValue, formStep]);

  const handleShowHeader = useMemo(() => {
    return (
      <>
        <Grid container alignItems="center">
          <Grid item sm={8} xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: isXsOrSm ? "25px" : "20px", // Space between the main sections
                paddingTop: isXsOrSm ? "10px" : "",
                paddingBottom: isXsOrSm ? "10px" : "",
              }}
            >
              {steps.map((elem: any, index: number) => {
                return (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: isXsOrSm ? "10px" : "20px", // Space between the two boxes within this section
                      }}
                    >
                      <Box
                        sx={{
                          width: isXsOrSm ? "30px" : "40px",
                          height: isXsOrSm ? "30px" : "40px",
                          background:
                            formStep == index
                              ? "rgba(0, 179, 181, 1)"
                              : formStep > index
                              ? "rgba(0, 179, 181, 0.08)"
                              : "rgba(75, 70, 92, 0.08)",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color:
                            formStep == index
                              ? "white"
                              : formStep > index
                              ? "rgba(0, 179, 181, 1)"
                              : "rgba(75, 70, 92, 1)",
                          fontWeight: "600",
                          fontSize: isXsOrSm ? "12px" : "16px",
                        }}
                      >
                        {index + 1}
                      </Box>
                      {isXsOrSm ? (
                        <Box>
                          <Typography
                            sx={{
                              color: "rgba(75, 70, 92, 1)",
                              fontWeight: "600",
                              fontSize: "12px",
                              lineHeight: "21px",
                            }}
                          >
                            {formStep == index && mobileSteps[index]}
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ paddingLeft: "5px" }}>
                          <Typography
                            sx={{
                              color: "rgba(75, 70, 92, 1)",
                              fontWeight: "600",
                              fontSize: "13px",
                              lineHeight: "21px",
                            }}
                          >
                            {elem}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {index < steps.length - 1 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <ArrowForwardIosIcon
                          sx={{
                            color: "rgba(75, 70, 92, 0.5)",
                            fontSize: "18px",
                          }}
                        />
                      </Box>
                    )}
                  </>
                );
              })}
            </Box>
          </Grid>

          {!isXsOrSm && (
            <>
              <Grid item sm={4} sx={{ justifyItems: "right" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start", // Ensures items align inline from left to right
                    gap: "26px", // Adds spacing between the text and progress circle
                  }}
                >
                  <Stack direction="column">
                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: "#B0B0B0",
                        fontWeight: 500,
                        marginBottom: "4px",
                      }}
                    >
                      Completion Rate
                    </Typography>
                  </Stack>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#00B3B5",
                      fontWeight: 600,
                    }}
                  >
                    {handleCompletionPercValue}%
                  </Typography>
                  <CircularProgress
                    variant="determinate"
                    value={handleCompletionPercValue}
                    sx={{
                      color: "#00B3B5",
                      borderRadius: "50%",
                    }}
                    thickness={5}
                    size={30}
                  />
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </>
    );
  }, [steps, mobileSteps, formStep, isXsOrSm]);

  /**
   * Updates the form value state with the specified key-value pair.
   *
   * @param {string} key - The key of the form value to update.
   * @param {any} value - The new value to set for the specified key.
   */
  const handleFormValue = (key: string, value: any) => {
    // Functional update: callers like the debounced pre-payment charge update run
    // with an older formValue and would otherwise overwrite newer keys (e.g. amount).
    setFormValue((prevFormValue: any) => ({ ...prevFormValue, [key]: value }));
  };

  const LoanTypeValue: any = userLoanCategory?.TermLoan.find(
    (elem: any) => elem?.id == dashboardDataSet?.[0]?.loanTypeId
  )?.loanTypeName;
  const loanCategoryValue: any = userLoanCategory?.TermLoan.find(
    (elem: any) => elem?.id == dashboardDataSet?.[0]?.loanTypeId
  );

  let breadcrumbItems = [
    { label: "Dashboard", path: "/" },
    { label: "Payments" }, // Current page, no `path` needed
  ];

  useEffect(() => {
    if (isXsOrSm) {
      if (!formTypeValue) {
        setFormStep(-1);
      }
    }

    if (!formTypeValue) {
      setpaymentType("");
    }
  }, [formTypeValue, formStep, isXsOrSm]);

  return (
    <PaymentTermLoanContext.Provider
      value={{
        isXsOrSm,
        LoanTypeValue,
        loanCategoryValue,
        formTypeValue,
        userProfile,
        isModalOpen,
        overdueAmount,
        selectedOptionValue,
        status,
        fromDate,
        toDate,
        dashboardData,
        selectedOptionFilterValue,
        message,
        severity,
        inputValue,
        nagitiveValueCheck,
        disabledButton,
        lanNumber,
        toastOpen,
        paymentTypeValue,
        errorMessage,
        isLoading,
        pending,
        totalRecords,
        rows,
        page,
        rowsPerPage,
        statusUpdate,
        rolePermissions,
        partPaymentData,
        formValue,
        applicableCharges,
        userLoanCategory,
        selectedLoanNumber,
        cif,
        LoanNo,
        paymentRequestId,
        termLoanRequestId,
        overDueValues,
        amountValue,
        dashboardDataSet,
        paymentType,
        isOverDuePending,
        isLoadingTableCard,

        setAmountValue,
        setTermLoanRequestId,
        setOverdueAmount,
        handleSelectPaymentType,
        setSelectedOptionValue,
        setFromDate,
        setToDate,
        setDashboardData,
        setSelectedOptionFilterValue,
        setMessage,
        setSeverity,
        setInputValue,
        setNagitiveValueCheck,
        setdisabledButton,
        setLanNumber,
        setToastOpen,
        setPaymentTypeValue,
        setErrorMessage,
        setIsLoading,
        setPending,
        setTotalRecords,
        setRows,
        setPage,
        setRowsPerPage,
        setstatusUpdate,
        setFormStep,
        handleFormValue,

        handleListItemClick,
        handleInputChange,
        handleFromDateChange,
        handleToDateChange,
        fetchData,
        handleChangePage,
        handleChangeRowsPerPage,
        handleToastClose,
        handleFilterButtonClick,
        handleCloseModal,
        handleEmptyFormValue,
      }}
    >
      {/* {formStep > -1 && (
        <CustomStepper
          activeStep={formStep}
          steps={handleShowSteps() === "PART_PAYMENT" ? steps : steps2}
        />
      )} */}

      <Grid container spacing={2}>
        {/* Left Section */}

        {formStep == -1 ? (
          <>
            <PaymentRequestTermLoan />
          </>
        ) : (
          <>
            {formStep != 3 && !isXsOrSm && (
              <>
                <br />
                <Box className="paddingLeft" sx={{ marginTop: "20px" }}>
                  <Breadcrumbs
                    items={breadcrumbItems}
                    onBackClick={() => {
                      setFormStep(-1);
                      dispatch(clearPartPaymentType());
                      handleSelectPaymentType("");
                    }}
                  />
                </Box>
              </>
            )}

            {formTypeValue == "1" && formStep != 3 && (
              <>
                <div
                  className={`${
                    isXsOrSm
                      ? "dashboard-container-mobile"
                      : "dashboard-container"
                  }  paddingLeft`}
                >
                  <Card>
                    <Box>
                      <Typography className="section-sub-heading mt-10 mb-20">
                        LOAN DETAILS
                      </Typography>
                    </Box>
                    {/* Adjusted spacing */}
                    <Grid container item mt={1} mb={isXsOrSm ? 1 : 0}>
                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageLableMobile"
                              : "insidePageLable"
                          }
                        >
                          Loan Account Number
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageValueMobile"
                              : "insidePageValueItem"
                          }
                          variant="subtitle1"
                        >
                          {dashboardData?.lanNumber}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageLableMobile"
                              : "insidePageLable"
                          }
                        >
                          Sanctioned Amount
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageValueMobile"
                              : "insidePageValueItem"
                          }
                          variant="subtitle1"
                        >
                          {formatIndianRupees(dashboardData?.repayAmount)}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageLableMobile"
                              : "insidePageLable"
                          }
                        >
                          {formTypeValue == "1" ? 
                            <Typography
                              className="insidePageLable"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: isXsOrSm ? undefined : "-6px",
                                fontSize: isXsOrSm ? "11px" : undefined,
                              }}
                            >
                              Outstanding Principal
                              <Tooltip
                                placement="top"
                                title={"Principal Outstanding Amount After Moratorium End (If Applicable)"}
                                enterTouchDelay={50}
                                sx={{ verticalAlign: "middle" }}
                              >
                                <img
                                  src={InfoIcon}
                                  alt="Status"
                                  className="imgicon"
                                  style={{
                                    marginLeft: 6,
                                    verticalAlign: "middle",
                                    marginTop: "5px",
                                  }}
                                />
                              </Tooltip>
                            </Typography>
                            : "Next EMI Payment Date"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageValueMobile"
                              : "insidePageValueItem"
                          }
                          variant="subtitle1"
                        >
                          {formatIndianRupees(
                            dashboardData?.paymentOutstandingPrincipal
                          )}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageLableMobile"
                              : "insidePageLable"
                          }
                        >
                          {formTypeValue == "1"
                            ? "Rate of Interest"
                            : "Next EMI Payment"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={3}
                        xs={6}
                        alignItems="center"
                        mb={isXsOrSm ? 0 : 1}
                      >
                        <Typography
                          className={
                            isXsOrSm
                              ? "insidePageValueMobile"
                              : "insidePageValueItem"
                          }
                          variant="subtitle1"
                        >
                          {dashboardData?.outstandingPrincipal} %
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </div>
              </>
            )}

            {formTypeValue == "1" && (
              <>
                <Grid item xs={12} sm={12} className="mt-10 paddingLeft">
                  {formStep == 3 ? (
                    <> {handleShowFormSection} </>
                  ) : (
                    <Card>
                      {handleShowHeader}
                      <Divider
                        sx={{
                          paddingBottom: isXsOrSm ? "5px" : "24px",
                          color: "#4B465C",
                        }}
                      />
                      {handleShowFormSection}
                    </Card>
                  )}
                </Grid>
              </>
            )}
            {formTypeValue == "2" && (
              <>
                <Grid item sm={12} className="mt-10 paddingLeft">
                  {formStep == 3 ? (
                    <> {handleShowFormSection} </>
                  ) : (
                    <>{handleShowOverdueForm}</>
                  )}
                </Grid>
              </>
            )}
          </>
        )}

        {/* Right Section */}

        {/* Bottom Section */}
        <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
          {/* Table section */}

          {formStep == -1 && (
            <>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography
                    className="loan-account-main-heading"
                    mb={isXsOrSm ? 2 : 0}
                  >
                    Previous Payment Details{" "}
                    <span style={{ fontSize: isXsOrSm ? "11px" : "16px" }}>
                      {" "}
                      (initiated via customer portal){" "}
                    </span>
                  </Typography>
                </Grid>

                {!isXsOrSm && (
                  <Grid item style={{ display: "inline-flex" }} gap={2}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontFamily: "Jost",
                        fontSize: "clamp(9px, 1.2vw, 11px)",
                        fontWeight: "500",
                        lineHeight: "19.36px",
                        textAlign: "left",
                        color: "#00B3B5",
                        width: "fit-content",
                        height: "27px",
                        padding: "14px 12px",
                        borderRadius: "4px",
                        border: "0.5px solid #00B3B5",
                        cursor: "pointer",
                      }}
                      onClick={handleFilterButtonClick}
                    >
                      <img
                        src={filterIcon}
                        alt="Filter Icon"
                        style={{ width: "13px", color: "#00B3B5" }}
                      />{" "}
                      Filter
                    </span>
                  </Grid>
                )}
              </Grid>

              {isXsOrSm ? (
                <>
                  <CardItemTermPayment
                    rows={rows}
                    isLoading={isLoadingTableCard}
                    handleActionClick={handleActionClick}
                  />
                </>
              ) : (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginTop: "15px" }}
                >
                  <Tables
                    columns={columns}
                    rows={rows}
                    page={page}
                    isLoading={isLoadingTableCard}
                    rowsPerPage={rowsPerPage}
                    totalRecords={totalRecords}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />{" "}
                </Grid>
              )}
            </>
          )}
        </Grid>

        {/* Snackbar for notifications */}
        <Toast
          open={toastOpen}
          message={message}
          severity={severity}
          onClose={handleToastClose}
        />
        {/* Modal for filters */}
        <ModalPopup
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title="Filter"
          onNavigate={() => {}}
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            padding: "16px 16px 63px 16px",
            margin: "0px",
            borderRadius: "8px 0px 0px 8px",
            height: "100vh",
            width: "340px",
            zIndex: 9999,
          }}
        >
          <SelectOptions
            options={filterOptionsPartPay}
            label="Select Option"
            isMandatory={false}
            value={selectedOptionFilterValue}
            onChange={(value: string | number) => {
              setSelectedOptionFilterValue(value);
            }}
          />
          <BasicDatePicker
            label="From Date"
            width="100%"
            onChange={handleFromDateChange}
            value={fromDate ? dayjs(fromDate) : null}
          />
          <BasicDatePicker
            label="To date"
            width="100%"
            onChange={handleToDateChange}
            value={toDate ? dayjs(toDate) : null}
          />
          <Box display="flex" justifyContent="space-between" gap={2} mt={2}>
            <SecondaryButtonText
              sx={{
                height: "39px",
                marginTop: "20px",
              }}
              variant="outlined"
              fullWidth
              onClick={clearData}   // <-- your clear handler
            >
              Clear
            </SecondaryButtonText>
            <PrimaryButton
              fullWidth
              type="submit"
              onClick={filterData}
              style={{ margin: "20px 0px" }}
            >
              Apply
            </PrimaryButton>
          </Box>
        </ModalPopup>
      </Grid>
    </PaymentTermLoanContext.Provider>
  );
};

export default PaymentTermLoan;
